import { GET_STATUS_CHECK } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getStatusCheck = (payload) => {
  return apiInstance.get(GET_STATUS_CHECK, payload);
};